import Vue from 'vue';
import App from './App.vue';
import '@/registerServiceWorker';
import '@/components';
import router from './router';
import { makeStore } from './store';
import '@vue-altoleap-libraries/vue-altoleap-accounts-ui/dist/vue-altoleap-accounts-ui.css';
import registerPlugins, { prepareServices } from './plugins';
import { vuetify } from './plugins';
import registerFilters from './filters';
import { VueQueryPlugin } from '@tanstack/vue-query';
import VueCompositionAPI, { createApp, h } from '@vue/composition-api';
import { sync } from 'vuex-router-sync';

Vue.use(VueCompositionAPI);
Vue.use(VueQueryPlugin);
Vue.config.productionTip = false;
Vue.config.performance = process.env.NODE_ENV === 'development';

const store = makeStore();
prepareServices(store);

sync(store, router);
registerPlugins(Vue, store, router);

registerFilters(Vue);
createApp({
  render() {
    return h(App);
  },
  router,
  store,
  vuetify
}).mount('#app');
